export default __webpack_public_path__ + "static/media/individual.08f7355e.svg";